/**
 * Dev-only chrome flag (solver controls, debug overlay, refresh). Vite sets
 * import.meta.env.DEV during `vite dev`; allow `?dev=1` so the prod bundle can
 * be inspected without redeploying. Shared by every composition so "dev chrome"
 * means the same thing on the viewer and in Studio.
 */
export const IS_DEV =
  import.meta.env.DEV ||
  (typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("dev") === "1");
